import type { LoaderFunctionArgs } from 'react-router-dom';
import { getOffer } from '../offers/apiHelpers';

export const offerLoader = async ({
  params: { offerId = '' },
}: LoaderFunctionArgs<{
  params: { offerId: string };
}>) => getOffer(offerId);
